import { useAppContext } from "AppContext";
import { GuestsObject } from "components/HeroSearchForm/type";
import NcInputNumber from "components/NcInputNumber/NcInputNumber";
import React, { useEffect, useState } from "react";
import { FC } from "react";
export interface GuestsInputProps {
  defaultValue?: GuestsObject;
  onChange?: (data: GuestsObject) => void;
  className?: string;
}

const GuestsInput: FC<GuestsInputProps> = ({
  defaultValue,
  onChange,
  className = "",
}) => {
  const { updateFilterState, filterState } = useAppContext();

  const [guestAdultsInputValue, setGuestAdultsInputValue] = useState(
    filterState?.guestNumber || 0
  );
  const [guestChildrenInputValue, setGuestChildrenInputValue] = useState(
    filterState?.number_of_children || 0
  );
  const [guestInfantsInputValue, setGuestInfantsInputValue] = useState(
    filterState?.number_of_infants || 0
  );

  useEffect(() => {
    setGuestAdultsInputValue(filterState?.guestNumber || 0);
  }, [filterState?.guestNumber]);
  useEffect(() => {
    setGuestChildrenInputValue(filterState?.number_of_children || 0);
  }, [filterState?.number_of_children]);
  useEffect(() => {
    setGuestInfantsInputValue(filterState?.number_of_infants || 0);
  }, [filterState?.number_of_infants]);

  const handleChangeData = (value: number, type: keyof GuestsObject) => {
    let newValue = {
      guestAdults: guestAdultsInputValue,
      guestChildren: guestChildrenInputValue,
      guestInfants: guestInfantsInputValue,
    };
    if (type === "guestAdults") {
      setGuestAdultsInputValue(value);
      newValue.guestAdults = value;
      updateFilterState("guestNumber", value)
    }
    if (type === "guestChildren") {
      setGuestChildrenInputValue(value);
      newValue.guestChildren = value;
      updateFilterState("number_of_children", value)

    }
    if (type === "guestInfants") {
      setGuestInfantsInputValue(value);
      newValue.guestInfants = value;
      updateFilterState("number_of_infants", value)

    }
    onChange && onChange(newValue);
  };

  return (
    <div className={`flex flex-col relative p-5 ${className}`}>
      <span className="mb-5 block font-semibold text-xl sm:text-2xl">
        {`Who's coming?`}
      </span>
      <NcInputNumber
        className="w-full"
        defaultValue={guestAdultsInputValue}
        onChange={(value) => handleChangeData(value, "guestAdults")}
        max={20}
        label="Adults"
        desc="Ages 13 or above"
      />
      <NcInputNumber
        className="w-full mt-6"
        defaultValue={guestChildrenInputValue}
        onChange={(value) => handleChangeData(value, "guestChildren")}
        max={20}
        label="Children"
        desc="Ages 2–12"
      />

      <NcInputNumber
        className="w-full mt-6"
        defaultValue={guestInfantsInputValue}
        onChange={(value) => handleChangeData(value, "guestInfants")}
        max={20}
        label="Infants"
        desc="Ages 0–2"
      />
    </div>
  );
};

export default GuestsInput;
